import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
import { computed } from "vue";
import { SelectInput, TextInput } from "@eudonet/opal";
import { addressFieldRows, } from "@/shared/utils/addressFieldConfig";
import { useAddressRegionOptions } from "@/shared/composables/useAddressRegionOptions";
import { useAddressCountryOptions } from "../../composables/useAddressCountryOptions";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AddressDetailsFields',
    props: {
        form: {},
        country: {},
        disabled: { type: Boolean },
        errors: {}
    },
    emits: ["update", "blur"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const rows = computed(() => addressFieldRows(props.country));
        const regionOptions = useAddressRegionOptions(() => props.form.country, () => props.country);
        const countryOptions = useAddressCountryOptions();
        function onFieldInput(field, value) {
            // NL house numbers are numeric-only; the suffix has its own field.
            emit("update", field.key, field.type === "numeric" ? value.replace(/\D/g, "") : value);
        }
        return (_ctx, _cache) => {
            return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row, rowIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: rowIndex,
                    class: _normalizeClass(row.length === 2 ? 'grid grid-cols-2 gap-x-4' : undefined)
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (field) => {
                        return _renderSlot(_ctx.$slots, field.key, {
                            key: field.key,
                            field: field
                        }, () => [
                            (field.type === 'region')
                                ? (_openBlock(), _createBlock(_unref(SelectInput), {
                                    key: 0,
                                    "model-value": __props.form[field.key],
                                    label: _ctx.$t(field.labelKey),
                                    options: _unref(regionOptions),
                                    disabled: __props.disabled,
                                    "full-width": "",
                                    "onUpdate:modelValue": ($event) => (onFieldInput(field, $event))
                                }, null, 8 /* PROPS */, ["model-value", "label", "options", "disabled", "onUpdate:modelValue"]))
                                : (field.type === 'country')
                                    ? (_openBlock(), _createBlock(_unref(SelectInput), {
                                        key: 1,
                                        "model-value": __props.form[field.key],
                                        label: _ctx.$t(field.labelKey),
                                        options: _unref(countryOptions),
                                        disabled: __props.disabled,
                                        "full-width": "",
                                        "onUpdate:modelValue": ($event) => (onFieldInput(field, $event))
                                    }, null, 8 /* PROPS */, ["model-value", "label", "options", "disabled", "onUpdate:modelValue"]))
                                    : (_openBlock(), _createBlock(_unref(TextInput), {
                                        key: 2,
                                        "model-value": __props.form[field.key],
                                        label: _ctx.$t(field.labelKey),
                                        required: field.required,
                                        disabled: __props.disabled,
                                        error: __props.errors?.[field.key],
                                        inputmode: field.type === 'numeric' ? 'numeric' : undefined,
                                        "full-width": "",
                                        "onUpdate:modelValue": ($event) => (onFieldInput(field, $event)),
                                        onBlur: ($event) => (_ctx.$emit('blur', field.key))
                                    }, null, 8 /* PROPS */, ["model-value", "label", "required", "disabled", "error", "inputmode", "onUpdate:modelValue", "onBlur"]))
                        ]);
                    }), 128 /* KEYED_FRAGMENT */))
                ], 2 /* CLASS */));
            }), 128 /* KEYED_FRAGMENT */));
        };
    }
});
